import { getColor } from '@xstyled/system';
export default {
    border: (value, { props }) => {
        if (typeof value === 'number')
            return `${value}px solid`;
        const values = value.split(' ');
        const [width, style = '', color] = values;
        const colorValue = getColor(color)(props) ?? '';
        return `${width} ${style} ${colorValue}`;
    },
    space: (value) => {
        return typeof value === 'string' ? value : `${value * 8}px`;
    }
};
